import { render, staticRenderFns } from "./MessagesWidget.vue?vue&type=template&id=d8518534&scoped=true&"
import script from "./MessagesWidget.vue?vue&type=script&lang=js&"
export * from "./MessagesWidget.vue?vue&type=script&lang=js&"
import style0 from "./MessagesWidget.vue?vue&type=style&index=0&id=d8518534&prod&scoped=true&lang=css&"
import style1 from "./MessagesWidget.vue?vue&type=style&index=1&id=d8518534&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8518534",
  null
  
)

export default component.exports